import Immutable from 'immutable';

// constants
import { SEARCHBOX_HIDE, SEARCHBOX_SHOW } from '../constants/searchTypes';
import httpReducer from '../lib/httpReducer';
import { SEARCHBOX_SEARCH_REP, SEARCHBOX_SEARCH_REP_CLEAR } from '../constants/searchTypes';

const show = function(state) {
  return state.set('showSearchBox', true);
};

const hide = function(state) {
  return state.set('showSearchBox', false);
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case SEARCHBOX_SHOW:              return show(state, action);
    case SEARCHBOX_HIDE:              return hide(state);
    case SEARCHBOX_SEARCH_REP:        return httpReducer(state, action);
    case SEARCHBOX_SEARCH_REP_CLEAR:  return Immutable.Map();
    default:                          return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/search.js